'use client';

import { useEffect } from 'react';
import { useUser } from '@/providers/UserProvider';
import { useServerLoggedInHint } from '@/providers/ServerAuthHintProvider';
import {
  linkWebPushContact,
  unlinkWebPushContact,
} from '@/lib/emarsys/web-push';
import { useWebPushState } from './web-push-provider';

export function WebPushContactBridge() {
  const push = useWebPushState();
  const { user, isLoggedIn } = useUser();
  const serverLoggedIn = useServerLoggedInHint();
  const config = push?.config;
  const subscribed = push?.subscribed ?? false;
  const customerId = isLoggedIn ? user?.id : undefined;

  useEffect(() => {
    if (!config?.contactFieldId || !subscribed) return;
    if (customerId) {
      linkWebPushContact(config, customerId).catch(() =>
        console.error('[WebPush] Contact linking failed'),
      );
      return;
    }
    // User starts as null until session restore finishes; only unlink when no session exists.
    if (serverLoggedIn) return;
    unlinkWebPushContact().catch(() =>
      console.error('[WebPush] Contact unlinking failed'),
    );
  }, [config, subscribed, customerId, serverLoggedIn]);

  return null;
}

